import { render } from "./PageCard.vue?vue&type=template&id=490209e2&scoped=true"
import script from "./PageCard.vue?vue&type=script&lang=js"
export * from "./PageCard.vue?vue&type=script&lang=js"

import "./PageCard.vue?vue&type=style&index=0&id=490209e2&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490209e2"]])

export default __exports__